import Currency from 'components/Currency'
import { options as codeOptions } from 'components/CustomsForm/CustomsItem/Form/CodeSelect'
import { options as preferenceCodeOptions } from 'components/CustomsForm/CustomsItem/Form/PreferenceCodeSelect'
import { options as taxCodeOptions } from 'components/CustomsForm/CustomsItem/Form/TaxCodeSelect'
import { useDialog } from 'components/Dialog'
import HeaderControls from 'components/InfinityTable/HeaderControls'
import ListContainer from 'components/InfinityTable/ListContainer'
import RowControls from 'components/InfinityTable/RowControls'
import Sort from 'components/InfinityTable/Sort'
import lodash from 'lodash'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import styled from 'styled-components'

import CustomsItemEditor from './CustomsItemEditor'

const HeaderRow = styled.div`
  font-weight: bold;
  text-transform: uppercase;
`

const OrderList = (props) => {
  const { applyFilter } = props
  const createModal = useDialog()
  const [editValues, setEditValues] = useState()

  useEffect(() => {
    applyFilter({ reset: true })
  }, [])

  const onCreate = () => {
    setEditValues()
    setTimeout(createModal.open, 0)
  }

  const onEdit = (values) => {
    setEditValues(values)
    setTimeout(createModal.open, 0)
  }

  const onRemove = (values) => {
    setEditValues({ ...values, isDelete: true })
    setTimeout(createModal.open, 0)
  }

  const refresh = () => applyFilter({ reset: true })

  const getIcon = (shortcode) => {
    const value = lodash.lowerCase(shortcode)
    switch (value) {
      case 'en':
        return 'gb'
      default:
        return value
    }
  }

  const headerControls = (
    <HeaderControls
      controls={[
        {
          label: i18n.t(`btn_add`, `Hinzufügen`),
          icon: 'far fa-plus',
          onClick: () => onCreate(),
        },
      ]}
    />
  )

  const rowControls = (rowProps) => {
    return (
      <RowControls
        {...rowProps}
        controls={[
          {
            icon: 'fas fa-pencil',
            onClick: () => onEdit(rowProps.rowData),
          },
          {
            icon: 'fas fa-trash-alt',
            variant: 'danger',
            onClick: () => onRemove(rowProps.rowData),
          },
        ]}
      />
    )
  }

  const mobileCellHeaderItems = ({ rowData }) => {
    return [
      {
        width: '50px',
        label: lodash.get(rowData, 'id', '?'),
      },
      {
        flex: '1',
        label: lodash.get(rowData, 'articleNumber'),
      },
      {
        flex: '1',
        label: lodash.get(rowData, 'description'),
      },
    ]
  }

  const mobileCellBody = ({ rowData }) => {
    return (
      <React.Fragment>
        <Row>
          <Col xs="4">
            <span className="font-weight-bold">ID:</span>
          </Col>
          <Col xs="8">
            <span>{lodash.get(rowData, 'id', '-')}</span>
          </Col>
        </Row>
        <Row>
          <Col xs="4">
            <span className="font-weight-bold">{i18n.t('label_art_nmb')}:</span>
          </Col>
          <Col xs="8">
            <span>{lodash.get(rowData, 'articleNumber', '-')}</span>
          </Col>
        </Row>
        <Row>
          <Col xs="4">
            <span className="font-weight-bold">
              {i18n.t('label_goods_name')}:
            </span>
          </Col>
          <Col xs="8">
            <span>{lodash.get(rowData, 'description', '-')}</span>
          </Col>
        </Row>
        <Row>
          <Col xs="4">
            <span className="font-weight-bold">
              {i18n.t('label_customs_nmb')}:
            </span>
          </Col>
          <Col xs="8">
            <span>{lodash.get(rowData, 'tariffNumber', '-')}</span>
          </Col>
        </Row>
        <Row>
          <Col xs="4">
            <span className="font-weight-bold">
              {t('label_country_origin')}:
            </span>
          </Col>
          <Col xs="8">
            <span>
              {' '}
              <i
                className={`flag-icon flag-icon-${getIcon(
                  rowData.originCountry,
                )}`}
              />
              {lodash.get(rowData, 'originCountry')}
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs="4">
            <span className="font-weight-bold">{t('label_value_goods')}:</span>
          </Col>
          <Col xs="8">
            <Currency
              value={lodash.get(rowData, 'value')}
              currency={lodash.get(rowData, 'valueCurrency')}
            />
          </Col>
        </Row>
        <Row>
          <Col xs="4">
            <span className="font-weight-bold">
              {t('label_sales_tax_code')}:
            </span>
          </Col>
          <Col xs="8">
            <div>
              {
                taxCodeOptions.find(
                  (o) =>
                    String(o.value) === String(lodash.get(rowData, 'taxCode')),
                ).label
              }
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs="4">
            <span className="font-weight-bold">{t('label_pref_code')}:</span>
          </Col>
          <Col xs="8">
            <div>
              {lodash.get(
                preferenceCodeOptions.find(
                  (o) =>
                    o.value === String(lodash.get(rowData, 'preferenceCode')),
                ),
                'label',
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs="4">
            <span className="font-weight-bold">{t('weight')}:</span>
          </Col>
          <Col xs="8">
            <div>
              {parseFloat(lodash.get(rowData, 'netWeight', 0)).toFixed(2)} kg
              <br />
              <span className="text-muted">
                ({parseFloat(lodash.get(rowData, 'grossWeight', 0)).toFixed(2)}{' '}
                kg)
              </span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs="4">
            <span className="font-weight-bold">{t('label_art_code')}:</span>
          </Col>
          <Col xs="8">
            <div>
              {
                codeOptions.find(
                  (o) =>
                    String(o.value) === String(lodash.get(rowData, 'code')),
                ).label
              }
            </div>
          </Col>
        </Row>
        <div className="p-2">{rowControls(props)}</div>
      </React.Fragment>
    )
  }

  const mobileColumn = [
    {
      headerRenderer: (renderprops) => (
        <HeaderRow className="d-flex justify-content-between align-items-center">
          <Sort
            {...props}
            sorts={props.sort}
            sortKey="id"
            applyFilter={props.applyFilter}
            setSort={props.setSort}
            sortableColumns={props.sortableColumns}
            label="#"
          />
          {headerControls}
        </HeaderRow>
      ),
    },
  ]
  const columns = [
    {
      label: '#',
      dataKey: 'id',
      sortKey: 'id',
      flexGrow: 0,
      width: 50,
    },
    {
      label: i18n.t('label_art_nmb2', 'Artikelnummer'),
      dataKey: 'articleNumber',
      sortKey: 'articleNumber',
      flexGrow: 0,
    },
    {
      label: i18n.t('label_goods_name', 'Warenbezeichnung'),
      dataKey: 'description',
      sortKey: 'description',
      flexGrow: 2,
    },
    {
      label: i18n.t('label_customs_nmb', 'Zolltarifnummer'),
      dataKey: 'tariffNumber',
      sortKey: 'tariffNumber',
    },
    {
      label: i18n.t('label_country_origin', 'Ursprungsland'),
      dataKey: 'originCountry',
      cellRenderer: ({ cellData }) => (
        <span>
          {' '}
          <i className={`flag-icon flag-icon-${getIcon(cellData)}`} />{' '}
          {cellData}
        </span>
      ),
    },
    {
      label: i18n.t('label_value_goods', 'Warenwert'),
      cellDataGetter: ({ rowData }) => ({
        value: lodash.get(rowData, 'value'),
        currency: lodash.get(rowData, 'valueCurrency'),
      }),
      cellRenderer: ({ cellData }) => {
        return cellData?.value && <Currency {...cellData} />
      },
    },
    {
      label: i18n.t('label_sales_tax_code', 'Steuersatz'),
      dataKey: 'taxCode',
      cellRenderer: ({ cellData }) =>
        cellData && (
          <div>
            {
              taxCodeOptions.find((o) => String(o.value) === String(cellData))
                .label
            }
          </div>
        ),
    },
    {
      label: i18n.t('label_pref_code', 'Präferenzcode'),
      dataKey: 'preferenceCode',
      cellRenderer: ({ rowData }) => {
        if (!rowData) {
          return null
        }
        return (
          <div>
            {lodash.get(
              preferenceCodeOptions.find(
                (o) => o.value === String(rowData.preferenceCode),
              ),
              'label',
            )}
          </div>
        )
      },
    },
    {
      label: i18n.t('weight', 'Gewicht'),
      cellRenderer: ({ rowData }) => {
        if (!rowData) {
          return null
        }
        return (
          <div>
            {parseFloat(rowData.netWeight).toFixed(2)} kg
            <br />
            <span className="text-muted">
              ({parseFloat(rowData.grossWeight).toFixed(2)} kg)
            </span>
          </div>
        )
      },
    },
    {
      label: i18n.t('label_art_code', 'Code'),
      cellDataGetter: ({ rowData }) => lodash.get(rowData, 'code'),
      cellRenderer: ({ cellData }) =>
        cellData && (
          <div>
            {
              codeOptions.find((o) => String(o.value) === String(cellData))
                .label
            }
          </div>
        ),
      flexGrow: 2,
    },
    {
      label: headerControls,
      dataKey: 'rowIndex',
      flexGrow: 1,
      cellRenderer: (rowProps) => (
        <div className="pr-2">{rowControls(rowProps)}</div>
      ),
    },
  ]

  const filter = [
    {
      name: 'articleNumber',
      label: i18n.t('label_art_nmb2', 'Artikelnummer'),
      type: 'value',
      autoFocus: true,
      colWidth: 12,
    },
    {
      name: 'description',
      label: i18n.t('label_goods_name', 'Warenbezeichnung'),
      type: 'value',
      colWidth: 12,
    },
    {
      name: 'tariffNumber',
      label: i18n.t('label_customs_nmb', 'Zolltarifnummer'),
      type: 'value',
      colWidth: 12,
    },
    {
      name: 'fulltext',
      label: i18n.t('included_fts_customslist', 'Volltextsuche'),
      type: 'fulltext',
      exludeForDetail: true,
      showForFts: true,
      colWidth: 12,
    },
  ]

  return (
    <React.Fragment>
      <CustomsItemEditor
        {...createModal}
        item={editValues}
        key={lodash.get(editValues, 'id')}
        refresh={refresh}
      />
      <ListContainer
        {...props}
        columns={columns}
        filter={filter}
        title={props.isSovereign ? null : 'Zollprodukte'}
        topMarginOrder
        rowHeight={100}
        mobileColumn={mobileColumn}
        mobileRowHeight={250}
        mobileRowHeightCollapsed={35}
        mobileCellBody={mobileCellBody}
        mobileCellHeaderItems={mobileCellHeaderItems}
      />
    </React.Fragment>
  )
}

export default OrderList
